import { InputSwitchComponent } from './input-switch/input-switch.component';
import { PipesModule } from '@app/pipes/pipes.module';
import { OnoffswitchComponent } from './onoffswitch/onoffswitch.component';
import { InputCheckComponent } from './input-check/input-check.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PanelSwitchComponent, PanelComponent } from '@app/modules/shared/panel-switch/panel-switch.component';
import { GoogleplaceDirective } from '@app/directives/googleplace';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CollapseModule,
    BsDropdownModule.forRoot(),
    PipesModule
  ],
  declarations: [
    PanelSwitchComponent,
    PanelComponent,
    OnoffswitchComponent,
    GoogleplaceDirective,
    InputSwitchComponent,
    InputCheckComponent
  ],
  exports: [
    PanelSwitchComponent,
    PanelComponent,
    OnoffswitchComponent,
    GoogleplaceDirective,
    InputSwitchComponent,
    InputCheckComponent
  ]
})
export class SharedModule { }
